import { Autocomplete, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, TextField, Typography } from '@mui/material'
import axios from 'axios'
import _ from 'lodash'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers'
import { useStyle } from '../../billing/style'
import CustomTable from '../customTable'
import { Helmet } from 'react-helmet-async'
import dayjs from 'dayjs'
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from 'moment'
import * as XLSX from 'xlsx';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';

const OtAllItemWise = () => {
    const dispatch = useDispatch()
    const classes = useStyle()
    const [data, setData] = useState([])
    const pageOption = [10, 25, 50, 100];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const [catData,setCatData] = useState([])
    const [subData,setSubData] = useState([])
    const [headData, setHeadData] = useState([])
    const [typeData, setTypeData] = useState([])
    const [supplier, setSupplier] = useState([]);
    const [outletName , setOutletName]=useState([])
    const outletId = localStorage.getItem('outlet_id')
  const[cust, setCust] = useState(null)

    const [options, setOptions] = useState({
        customer:null,
        head: null,
        type: null,
        category : null,
        subCategory : null,
        fromDate: moment().subtract(1 , 'years' ).format(),
        toDate :  moment().format()
    })
    // const [csvData, setCsvData] = useState('');

    // const generateCSV = () => {
    //   let csvContent = "data:text/csv;charset=utf-8,";
  
    //   // Create CSV header
    //   let header = [
    //     "S.no",
    //     "Product Name",
    //     "Product Code",
    //     "Head Name",
    //     "Type Name",
    //     "Category Name",
    //     "Subcategory Name",
    //     "Total Qty",
    //     "Total Amount",
    //     ...outletName.map(outlet => [`${outlet.outlet_name} Quantity`, `${outlet.outlet_name} Amount`]).flat()
    //   ];
  
    //   csvContent += header.join(",") + "\r\n";
  
    //   // Add data rows
    //   data.forEach((value, idx) => {
    //     let row = [
    //       idx + 1,
    //       value.pro_name || "-",
    //       value.pro_code || "-",
    //       value.head_name || "-",
    //       value.type_name || "-",
    //       value.category_name || "-",
    //       value.subcategory_name || "-",
    //       value.total_qty || "-",
    //       parseFloat(value.total_amount).toFixed(2) || "-"
    //     ];
  
    //     outletName.forEach(outlet => {
    //       const outletDetail = value.outlet_details.find(detail => detail.outlet_code === outlet.outlet_code) || {};
    //       row.push(outletDetail.total_qty || "-");
    //       row.push(parseFloat(outletDetail.total_amount).toFixed(2) || "-");
    //     });
  
    //     csvContent += row.join(",") + "\r\n";
    //   });
  
    //   setCsvData(encodeURI(csvContent));
    // };
  

    function handleChange(value, name){
        console.log(name, value)
        if (name === 'fromDate' || name === 'toDate') {
          // If the name is fromDate or toDate, format the date with dayjs
          const formattedDate = dayjs(value).format('YYYY-MM-DD');
          setOptions(prev => ({ ...prev, [name]: formattedDate }));
      } else {
          // For other fields, set directly
          setOptions(prev => ({ ...prev, [name]: value }));
      }
    }
    function getItemData(){
      const allItems = {
        from_date : moment(options.fromDate).format('YYYY-MM-DD'),
        to_date :  moment(options.toDate).format('YYYY-MM-DD'),
        customer:cust!==null ? cust.id : outletId,
        category:options.category===null ? 0 : options.category.id,
        subcategory:options.subCategory===null ? 0 : options.subCategory.id,
        type:options.type===null ? 0 : options.type.id,
        head:options.head===null ? 0 : options.head.id
      }
        // axios.post(`/v1/reports/item/${options.head===null ? 0 : options.head.id}/${options.type===null ? 0 : options.type.id}/${options.category===null ? 0 : options.category.id}/${options.subCategory===null ? 0 : options.subCategory.id}/${rowsPerPage}/${page + 1}`)
        axios.post(`/v1/reports/outlet_sales/itemwise/alloutlets` ,allItems)
        .then(res=>{
          setOutletName(res.data[0].outlets_names_header);
          const responseData = res.data.slice(1);
          if (responseData.length > 0) {
              setData(responseData);
          } else {
          }
        })
        .catch(err=>{
            console.log(err)
            dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
        })
    }
    function getHead(){
        axios.get('/v1/Head')
        .then(res=>{
            setHeadData(res.data)
        })
        .catch(err=>{
            dispatch(setSnackbar(true,'error',err.response.error))
        })
    }
    function getTypeData(){
        axios.get('/v1/typedesign')
        .then(res=>{
            setTypeData(res.data)
        })
        .catch(err=>{
            dispatch(setSnackbar(true,'error',err.response.error))
        })
    }
    function getCategory(){
        axios.get('/v1/categories')
        .then(res=>{
            _.filter(res.data, val=>{
                if(val.is_active){
                     setCatData(res.data)
                }
            })
        })
        .catch(err=>{
            console.log(err.response.data.error)
            dispatch(setSnackbar(true,'error',err.response.data.error))
        })
    }
    function getSubCategory(){
        axios.get('/v1/subcategories')
        .then(res=>{
                setSubData(res.data)
        })
        .catch(err=>{
            console.log(err.response.data.error)
            dispatch(setSnackbar(true,'error',err.response.data.error))
        })
    }
    function getSupplierData() {
      axios
        .get("/v1/outlet/list/1")
        .then((res) => {
          _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))
          console.log(res.data)
          setSupplier(res.data);
        })
        .catch((err) => {
          dispatch(setSnackbar(true, "error", err.response.data.error));
        });
    }
  //   function exportToExcel() {
  //     const wb = XLSX.utils.book_new();
      
  //     // Prepare the data for Excel
  //     const excelData = [
  //       // Headers
  //       [
  //           'S.no',
  //           'Product Name',
  //           'Product Code',
  //           'Brand',
  //           'Type',
  //           'Category',
  //           'Subcategory',
  //           'Total Qty',
  //           'Total Amount',
  //           ...outletName.flatMap(outlet => [
  //               `${outlet.outlet_name || "-"}`,
  //               `${outlet.outlet_name || "-"}`,
  //               // '', // Empty cell for the first child header
  //               // '', // Empty cell for the second child header
  //           ])
  //       ],
  //       // Subheaders for Qty and Amount
  //       [
  //           '', // Empty cell for the first main header
  //           '', // Empty cell for the second main header
  //           '',
  //           '',
  //           '',
  //           '',
  //           '',
  //           '',
  //           '',
  //           ...outletName.flatMap(outlet => [
  //               'Qty', // Bold text for Qty
  //               'Amount', // Bold text for Amount
  //           ])
  //       ],
  //       // Data rows
  //       ...data.map((value, idx) => [
  //           idx + 1,
  //           value.pro_name || "-",
  //           value.pro_code || "-",
  //           value.head_name || "-",
  //           value.type_name || "-",
  //           value.category_name || "-",
  //           value.subcategory_name || "-",
  //           value.total_qty || "-",
  //           parseFloat(value.total_amount).toFixed(2) || "-",
  //           ...outletName.flatMap(outlet => {
  //               const outletDetail = value.outlet_details.find(detail => detail.outlet_code === outlet.outlet_code);
  //               return [
  //                   outletDetail ? outletDetail.qty || "-" : "-",
  //                   outletDetail ? parseFloat(outletDetail.amount).toFixed(2) || "-" : "-"
  //               ];
  //           })
  //       ])
  //   ]; 

  //     const ws = XLSX.utils.aoa_to_sheet(excelData);
  //     XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  //     XLSX.writeFile(wb, "data.xlsx");
  // }
  function exportToExcel() {
    const wb = XLSX.utils.book_new();
    
    // Calculate the totals
    let totalQty = 0;
    let totalAmount = 0;
    const outletTotals = outletName.map(() => ({ qty: 0, amount: 0 }));

    data.forEach(value => {
        totalQty += value.total_qty || 0;
        totalAmount += parseFloat(value.total_amount) || 0;

        value.outlet_details.forEach((detail, idx) => {
            const outletIndex = outletName.findIndex(outlet => outlet.outlet_code === detail.outlet_code);
            if (outletIndex !== -1) {
                outletTotals[outletIndex].qty += detail.qty || 0;
                outletTotals[outletIndex].amount += parseFloat(detail.amount) || 0;
            }
        });
    });

    // Prepare the data for Excel
    const excelData = [
        // Headers
        [
            'S.no',
            'Product Name',
            'Product Code',
            'Brand',
            'Type',
            'Category',
            'Subcategory',
            'Total Qty',
            'Total Amount',
            ...outletName.flatMap(outlet => [
                `${outlet.outlet_name || "-"}`,
                `${outlet.outlet_name || "-"}`,
            ])
        ],
        // Subheaders for Qty and Amount
        [
            '', // Empty cell for the first main header
            '', // Empty cell for the second main header
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            ...outletName.flatMap(outlet => [
                'Qty', // Bold text for Qty
                'Amount', // Bold text for Amount
            ])
        ],
        // Data rows
        ...data.map((value, idx) => [
            idx + 1,
            value.pro_name || "-",
            value.pro_code || "-",
            value.head_name || "-",
            value.type_name || "-",
            value.category_name || "-",
            value.subcategory_name || "-",
            value.total_qty || "-",
            parseFloat(value.total_amount).toFixed(0) || "-",
            ...outletName.flatMap(outlet => {
                const outletDetail = value.outlet_details.find(detail => detail.outlet_code === outlet.outlet_code);
                return [
                    outletDetail ? outletDetail.qty || "-" : "-",
                    outletDetail ? parseFloat(outletDetail.amount).toFixed(0) || "-" : "-"
                ];
            })
        ]),
        // Total row
        [
            '', // Empty cell for Product Name
            '', // Empty cell for Product Code
            '', // Empty cell for Brand
            '', // Empty cell for Type
            '', // Empty cell for Category
            '', // Empty cell for Subcategory
            'Total',
            totalQty, // Total Qty
            totalAmount.toFixed(0), // Total Amount
            ...outletTotals.flatMap(total => [
                total.qty, // Total Outlet Qty
                total.amount.toFixed(0), // Total Outlet Amount
            ])
        ]
    ];

    const ws = XLSX.utils.aoa_to_sheet(excelData);
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Outlet All Item Wise.xlsx");
}

    useEffect(()=>{
        getCategory()
        getSubCategory()
        getHead()
        getTypeData()
        getSupplierData()
    },[])
    useEffect(()=>{
        getItemData()
    },[rowsPerPage, page, options , cust])
  return (
    <Fragment>
      <Helmet><title>Outlet All Item Wise</title></Helmet>
            <Typography variant="h5">Outlet All Item Wise</Typography>
    <Grid container spacing={2} className='p-2 pt-2'>
    <Grid item md={3}>
          <Autocomplete 
           value={cust}
           options={supplier}
           onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.fullname}
            renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
          />
        </Grid>
    <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(options.fromDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'},
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(options.toDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
    <Grid item md={3}>
      <Autocomplete 
        size='small'
        value={options.head}
        options={headData}
        getOptionLabel={option=>option.cateogory_name}
        onChange={(e,value)=>handleChange(value,'head')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Brand'/>
          )}
        />
      </Grid>
      <Grid item md={3}>
      <Autocomplete 
        size='small'
        options={typeData}
        value={options.type}
        getOptionLabel={option=>option.type_name}
        onChange={(e,value)=>handleChange(value,'type')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Type Design'/>
          )}
        />
      </Grid>
      <Grid item md={3}>
      <Autocomplete 
        size='small'
        value={options.category}
        options={catData}
        getOptionLabel={option=>option.category_name}
        onChange={(e,value)=>handleChange(value,'category')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Category'/>
          )}
        />
      </Grid>
      <Grid item md={3}>
      <Autocomplete 
        size='small'
        options={subData}
        value={options.subCategory}
        getOptionLabel={option=>option.subcategory_name}
        onChange={(e,value)=>handleChange(value,'subCategory')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Sub Category'/>
          )}
        />
      </Grid>
    </Grid>
    {/* <Button variant="contained" color="primary" onClick={generateCSV}>Download CSV</Button> */}
    {/* <Paper sx={{ width: '100%', overflow: 'hidden' }}> */}
    <Grid className='text-end my-2'>
    <Button onClick={exportToExcel} variant="outlined" > Export to Excel <SimCardDownloadOutlinedIcon /></Button>
      </Grid>
    <TableContainer className={classes.tblRoot} sx={{ maxHeight:600 }}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead className={classes.tblHeader} sx={{position: "sticky",top: 0,}}>
          <TableRow className={classes.tablrow}>
              <TableCell rowSpan={2} sx={{minWidth:70,}}>S.no</TableCell>
              <TableCell  rowSpan={2} sx={{minWidth:250}}>Product Name</TableCell>
              <TableCell  rowSpan={2} sx={{minWidth:150}}>Product Code</TableCell>
              <TableCell  rowSpan={2} sx={{minWidth:150}}>Brand </TableCell>
              <TableCell  rowSpan={2} sx={{minWidth:150}}>Type </TableCell>
              <TableCell  rowSpan={2} sx={{minWidth:150}}>Category </TableCell>
              <TableCell  rowSpan={2} sx={{minWidth:150}}>Subcategory </TableCell>
              <TableCell rowSpan={2} sx={{minWidth:70}}>Total Qty</TableCell>
              <TableCell rowSpan={2} sx={{minWidth:130}}>Total Amount</TableCell>
              {_.map(outletName , (val,idx) => (
                 <React.Fragment key={idx}>
                  <TableCell colSpan={2} sx={{minWidth:180}}>{val.outlet_name || "-"}</TableCell>
                  </React.Fragment>
              ))}
          </TableRow>
          <TableRow  className={classes.tablrow}>
          {_.map(outletName, (val, idx) => (
            <React.Fragment key={idx}>
                <TableCell>Quantity</TableCell>
                <TableCell>Amount</TableCell>
            </React.Fragment>
        ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {_.map(data , (value, idx) => (
            <TableRow key={idx}  className={classes.tablrow}>
              <TableCell>{idx + 1}</TableCell>
              <TableCell>{value.pro_name || "-"}</TableCell>
              <TableCell>{value.pro_code || "-"}</TableCell>
              <TableCell>{value.head_name || "-"}</TableCell>
              <TableCell>{value.type_name || "-"}</TableCell>
              <TableCell>{value.category_name || "-"}</TableCell>
              <TableCell>{value.subcategory_name || "-"}</TableCell>
              <TableCell>{value.total_qty || "-"}</TableCell>
              <TableCell sx={{ textAlign: "right !important",fontWeight:"bold" }}>{parseFloat(value.total_amount).toFixed(0) || "-"}</TableCell>
              {outletName.map((outlet, index) => {
                const outletDetail = value.outlet_details.find(detail => detail.outlet_code === outlet.outlet_code);
                return (
                  <React.Fragment key={index}>
                    <TableCell>{outletDetail ? outletDetail.qty || "-" : "-"}</TableCell>
                    <TableCell sx={{ textAlign: "right !important",fontWeight:"bold" }}>{outletDetail ? parseFloat(outletDetail.amount).toFixed(0) || "-" : "-"}</TableCell>
                  </React.Fragment>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
        <TableFooter sx={{ position: 'sticky', bottom: 0, backgroundColor: 'white', zIndex: 1 }}>
      <TableRow>
        <TableCell colSpan={7} sx={{ fontWeight: 'bold', textAlign: 'right',color:"#000",fontSize:16 }}>Total</TableCell>
        <TableCell sx={{ fontWeight: 'bold',fontSize:16, textAlign: "right !important",color:"#000",paddingRight:"0 !important" }}>
          {data.reduce((sum, item) => sum + (item.total_qty || 0), 0)}
        </TableCell>
        <TableCell sx={{ fontWeight: 'bold', textAlign: "right !important" ,fontSize:16,color:"#000",paddingRight:"0 !important" }}>
       {data.reduce((sum, item) => sum + parseFloat(item.total_amount || 0), 0).toFixed(0)}
        </TableCell>
        {outletName.map((outlet, idx) => {
          const totalQty = data.reduce((sum, item) => {
            const outletDetail = item.outlet_details.find(detail => detail.outlet_code === outlet.outlet_code);
            return sum + (outletDetail ? outletDetail.qty || 0 : 0);
          }, 0);
          const totalAmount = data.reduce((sum, item) => {
            const outletDetail = item.outlet_details.find(detail => detail.outlet_code === outlet.outlet_code);
            return sum + parseFloat(outletDetail ? outletDetail.amount || 0 : 0);
          }, 0).toFixed(2);
          
          return (
            <React.Fragment key={idx}>
              <TableCell sx={{ fontWeight: 'bold',fontSize:16,textAlign:"right !important",color:"#000",paddingRight:"0 !important" }}>{totalQty}</TableCell>
              <TableCell sx={{  fontWeight: 'bold',fontSize:16,textAlign:"right !important",color:"#000" ,paddingRight:"0 !important" }}> {totalAmount}</TableCell>
            </React.Fragment>
          );
        })}
      </TableRow>
    </TableFooter>
      </Table>

    </TableContainer>
    {/* </Paper> */}
    
    {/* {csvData && <a href={csvData} download="table_data.csv" style={{ display: 'none' }}>Download</a>} */}
    </Fragment>
  )
}

export default OtAllItemWise